import {
  Box,
  CircularProgress,
  CssBaseline,
  ThemeProvider,
} from "@mui/material";
import React, { memo, useEffect } from "react";
import FilterAndMap from "./components/filterAndMap/FilterAndMap";
import { theme } from "./theme/theme";
import { useDispatch } from "react-redux";
import {
  setAllStationList,
  setStationList,
} from "./redux/features/stations/stationsSlice";

const isDev = process.env.REACT_APP_TYPE === "development";
const App = memo(() => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      try {
        if (!isDev && !window?.ekoSettings) return null;
        setLoading(true);

        const response = await fetch(
          !isDev
            ? window?.ekoSettings?.apiUrl + "/eko/v1/stations"
            : "https://wordpress-550183-4992717.cloudwaysapps.com/index.php/wp-json/eko/v1/stations"
        );

        if (response.ok) {
          const data = await response.json();
          const stations =
            data.stations.filter((i) => i.latitude && i.longitude) || [];
          dispatch(setStationList(stations));
          dispatch(setAllStationList(stations));
        }
      } catch (error) {
        console.error("Error fetching station list:", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
    // eslint-disable-next-line
  }, [window?.ekoSettings]);

  return (
    <ThemeProvider theme={theme}>
      {loading || (!isDev && !window?.ekoSettings) ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <CssBaseline />
          <FilterAndMap />
        </Box>
      )}
    </ThemeProvider>
  );
});

export default App;
